module.exports = __webpack_public_path__ + "static/media/energy_card_multi_2.86f624b9.svg";